var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDischarging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient1",
    gradientUnits: "userSpaceOnUse",
    x1: 18.6972,
    y1: 41.9092,
    x2: 17.0722,
    y2: 10.1592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF6600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F1A029"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient2",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4746,
    y1: 29.3451,
    x2: 18.4746,
    y2: 7.5951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FF6600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F1A029"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,3.3h-3.4V1.1h-6.3v2.1h-3.5C9.9,3.3,9,4.1,9,5.1V32c0,1,0.8,1.8,1.8,1.8h13.2     c1,0,1.8-0.8,1.8-1.8V5.1C26,4.1,25.2,3.3,24.2,3.3z M11.5,5.7h3.1h5.8h3.1c0.4,0,0.7,0.3,0.7,0.7v25.1H10.8V6.4     C10.8,5.9,11.1,5.7,11.5,5.7z",
    fill: "url(#gradient1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 26.7,
    width: 12.4,
    height: 4.3,
    fill: "url(#gradient2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 21.9,
    width: 12.4,
    height: 4.3,
    fill: "url(#gradient2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 17.2,
    width: 12.4,
    height: 4.3,
    fill: "url(#gradient2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 12.4,
    width: 12.4,
    height: 4.3,
    fill: "url(#gradient2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischarging);
export default __webpack_public_path__ + "static/media/discharging.89a2d92674b0492edc3bf2dbbb888453.svg";
export { ForwardRef as ReactComponent };